<template>

    <div class="step1content" :class="{'tablet' : tablet}">
    
        <h1>Plan Your Route In<br>Augmented Reality</h1>
        <img src="@/assets/images/ar-terrain/img-ar-step1-content.webp">
        <p class="mt-2">Although more than 15 different routes have been pioneered to the summit of Everest, most climbers opt for one of two established routes.</p>
        
    </div>

</template>


<script>

export default {

    name: 'Step1Content',

    props: ['tablet'],
    
    data() {
        return {
            componentName: this.$options.name + ' Component'
        }
    },
    
    created() {
        
    },
    
    mounted() {
        
    },
    
    methods: {
        
    }
    
}

</script>


<style lang="scss" scoped>

.step1content {
    color: #4d5384;
    font-size: 15px;
    line-height: 24px;
    font-weight: $font-weight-medium;
    height: 430px;
    display: flex;
    flex-direction: column;
    align-items: center;

    @media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (-webkit-min-device-pixel-ratio: 2) {
        height: 365px;
    }
    
    @media only screen
    and (min-device-width : 360px)
    and (max-device-width : 640px)
    and (-webkit-min-device-pixel-ratio: 4) { 
        height: 365px;
    }

    &.tablet {
        height: 700px;
        font-size: 24px;
        line-height: 40px;

        & h1 {
            font-size: 26px;
            line-height: 30px;
            margin: 20px 0 0;
        }

        & img {
            width: 620px;
            margin-top: 20px;
        }

        & p {
            padding: 30px 0 0 0;
        }
    }

    & h1 {
        color: #0f005d;
        font-size: 16px;
        font-weight: $font-weight-extrabold;
        line-height: 20px;
        margin: 10px 0 0;
        text-transform: uppercase;
    }

    & img {
        width: 355px;

        @media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (-webkit-min-device-pixel-ratio: 2) {
            width: 300px;
        }
        
        @media only screen
        and (min-device-width : 360px)
        and (max-device-width : 640px)
        and (-webkit-min-device-pixel-ratio: 4) { 
            width: 300px;
        }
    }

    & p {
        max-width: 600px;
        margin: 0 auto;
        padding: 0 20px;

        @media only screen and (min-device-width: 375px) and (max-device-height: 667px) and (-webkit-min-device-pixel-ratio: 2) {
            padding: 0 15px;
        }

        @media only screen
        and (min-device-width : 360px)
        and (max-device-width : 640px)
        and (-webkit-min-device-pixel-ratio: 4) { 
            padding: 0 15px;
        }
    }
}

</style>
